import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import './LogoutPopup.css';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';
import { resetUserSettingState } from '../../../core/actions/actions';
import * as actions from '../../../core/actions/auth.action';
import { resetPageLimit } from '../../../core/actions/common.action';
import { resetAllSensorState } from '../../../core/actions/sensors.action';

interface Props {
    modalClosed: () => void;
}

const LogoutPopup: React.FC<Props> = props => {

    const dispatch = useDispatch();

    const logout = () => {
        dispatch(actions.logout())
	    dispatch(resetAllSensorState());
        dispatch(resetPageLimit());
        dispatch(resetUserSettingState());
    }

    return (

        <Modal show={true} centered onHide={props.modalClosed} dialogClassName="no-data-found-popup">
            <Modal.Header closeButton>
                <Modal.Title><FormattedMessage id='Application_Title' /></Modal.Title>
            </Modal.Header>
            <Modal.Body><div className="bootbox-body"><FormattedMessage id='Logout_Message' /></div></Modal.Body>
            <Modal.Footer>
                {/* <LoaderButton type="submit" onClick={props.modalSubmit} isLoading={props.isLoading} text="Button_Confirm"/>  */}
                <Button variant="primary" onClick={props.modalClosed} className="btnOkSize">
                    <FormattedMessage id='Button_Cancel' />
                </Button>
                <Button variant="primary" onClick={logout} className="btnOkSize">
                    <FormattedMessage id='Logout' />
                </Button>
            </Modal.Footer>
        </Modal>

    );
};

export default LogoutPopup;
